import react from 'react';
import './login_style.css';
import Credentials from './Credentials';
import ClientLogin from './ClientLogin';
import Client from './Client';
import Hotel from './Hotel';
import FetchHotelInfo from './FetchHotelInfo';
import './hotelInfo.css';
import Statistics from './Statistics';
import Test from './Test';

class HotelInfoPage extends react.Component{
    constructor(props){
        super(props);
        this.role=localStorage.role;
        this.state={
            searchLoc:'',
            client:JSON.parse(localStorage.user).user,
            reviewMessage:'',
            reviewRating:10,
            refreshReviews:true,
            reset:false
        };
        var item=JSON.parse(localStorage.hotel).hotel;
        this.client=new Client(this.state.client.username,this.state.client.email,this.state.client.profilePic,this.state.client.auth);
        this.hotel=new Hotel(item.id,item.identifier,item.hotelName,item.locationName,item.averageRating,item.votes,item.hotelUrl,item.photoLink,item.description,item.price);
        this.items=[];
        this.mapLoc=this.hotel.locationName.replace('ș','s');

        this.hotelInfo=FetchHotelInfo.fetchInfo(this.hotel.hotelUrl+".html");

        this.images=[];
        this.indicators=[];

        this.images.push(
            <div class="item active">
                    <img style={{width:"400px",height:"300px"}} src={this.hotelInfo.img[0]} class="img-responsive" alt="error" />
                </div>
        );
        this.indicators.push(
            <li data-target="#myCarousel-2" data-slide-to="0" class="active"></li>
        );

        for(const [index,url] of this.hotelInfo.img.entries()){
            if(index==0){
                continue;
            }
            this.indicators.push(
                <li data-target="#myCarousel-2" data-slide-to={index} class=""></li>
            );
            this.images.push(
                <div class="item">
                    <img style={{width:"400px",height:"300px"}} src={url} class="img-responsive" alt="error" />
                </div>
            );
        }

        var today='2021-05-26';
        var lastWeek='2021-05-16';

        var locationName=this.hotel.locationName.replace("ș","s");

        var data=Statistics.getWeatherStatistics(locationName,today).data[0];
        this.weather={windSpeed:data.wind_spd,clouds:data.clouds,prec:data.precip,pressure:data.pres,snow:data.snow,maxTemp:data.max_temp,minTemp:data.min_temp,maxUV:data.max_uv};
        this.pollution=Statistics.getPollutionStatistics(locationName)[0];
        this.covid=Statistics.getCovidStatistics(locationName,lastWeek,today);
        this.covidNews=Statistics.getCovidNews(locationName,'5')[0].results;
        this.covidNewsHtml=[];
        for(const [index,news] of this.covidNews.entries()){
            this.covidNewsHtml.push(
                <div style={{position:'relative'}}>
                    <h3>{news.title}</h3>
                    <a href={news.link}>{news.snippet}</a>
                    <hr />
                </div>
            );
        }
        this.restaurant=Statistics.getRestaurantStatistics(locationName)[0];
    }

    myChangeHandler = (event) => {
        if(!event.target.validity.valid){
            return;
        }
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({[nam] : val});
    }

    addReview = () => {
        if(this.role===''){
            alert("You are not logged in!");
            return;
        }
        this.client.review_add(this.hotel,this.state.reviewMessage,this.state.reviewRating);
        this.setState({reviewMessage:'',refreshReviews:true});
    }

    deleteReview = (id) => {
        this.client.review_delete(id);
        this.setState({refreshReviews:true});
    }

    search = (event) =>{
        if(event.keyCode!=13){
            return;
        }
        window.location="/search?location="+this.state.searchLoc;
    }

    render(){
        var weather=this.weather;
        var pollution=this.pollution;
        var covid=this.covid;
        var covidNewsHtml=this.covidNewsHtml;
        var restaurant=this.restaurant;

        if(this.state.refreshReviews){
            this.items=[];
            this.state.refreshReviews=false;
            var reviews=this.client.get_reviews(this.hotel.identifier);

            for(const [index,item] of reviews.entries()){
                var DeleteBtn=<span></span>;
                if(item.userName==this.client.username){
                    DeleteBtn=<span style={{border:'1px solid red',color:'red'}} class="pull-right" onClick={() => {this.deleteReview(item.id);}}>
                    X
                </span>;
                }
            this.items.push(
                <li class="message" style={{fontSize:'large'}}>
                    <span class="message-text">
                    <a href="javascript:void(0);" class="username">
                        {item.userName}
                        {DeleteBtn}
                        <span class="pull-right">
                            Rating : {item.userRating} / 10
                        </span>
                        <small class="text-muted pull-right ultra-light"> Posted on : {item.reviewDate} </small>
                    </a>
                    <h5> {item.reviewMessage}</h5>
                    </span>
                </li>
                );
            }
        }

        var AddBtn=<button class="btn btn-white btn-default" onClick={() => {if(this.role===''){alert("You are not logged in!");return;}var data=this.client.addToFavorites(this.hotel);alert(data.message);}}> <i class="far fa-heart"></i>Add to favorites</button>;
        if(this.role==='owner'){
            AddBtn=<span></span>;
        }

        var ReviewForm=<div class="well padding-bottom-10" >
        <textarea style={{fontSize:'large'}} rows="2" class="form-control" value={this.state.reviewMessage} onChange={this.myChangeHandler} name="reviewMessage" placeholder="Write a review"></textarea>
        <span>Rating (0-10):</span><input type="text" onChange={this.myChangeHandler} pattern="[0-9]|10" name="reviewRating" value={this.state.reviewRating}/>
        <div class="margin-top-10">
            <button type="submit" style={{fontSize:'large'}} class="btn btn-sm btn-primary pull-right" onClick={this.addReview}>
                Submit Review
            </button>
        </div>
    </div>;

    if(this.role==='owner'){
        ReviewForm=<span></span>;
    }


        return(
           

<div class="hotel-info">
<div class="topnav">
        <a class="active" href="/">Home</a>
        <a href="/statistics">Statistics</a>
        <a href="/profile">Your profile </a>
        <a href="/login">{(this.role==='')? "Login":"Sign out"}</a>
        <input type="text" placeholder="Search location" name="searchLoc" onKeyUp={this.search} onChange={this.myChangeHandler}/>
    </div>
<div class="col-sm-12 col-md-12 col-lg-12">
    <div class="product-content product-wrap clearfix product-deatil">
        <div class="row">
            <div class="col-md-5 col-sm-12 col-xs-12">
                <div class="product-image">
                    <div id="myCarousel-2" class="carousel slide">
                        <ol class="carousel-indicators">
                            {this.indicators}
                        </ol>
                        <div class="carousel-inner">
                            {this.images}
                        </div>
                        <a class="left carousel-control" href="#myCarousel-2" data-slide="prev"> <span class="glyphicon glyphicon-chevron-left"></span> </a>
                        <a class="right carousel-control" href="#myCarousel-2" data-slide="next"> <span class="glyphicon glyphicon-chevron-right"></span> </a>
                    </div>
                </div>
                
            </div>
            
                    <div class="btn-group pull-right">
                        {AddBtn}
                        
                    </div>
            <div class="content col-md-6 col-md-offset-1 col-sm-12 col-xs-12">
                
                <h2 class="name">
                    <a href={this.hotel.hotelUrl}>
                    {this.hotel.hotelName}
                    <small><h5><i class="fas fa-map-marker-alt" ></i> {this.hotel.locationName} </h5></small>
                    <i class="fas fa-star fa-2x "></i>
                    <i class="fas fa-star fa-2x "></i>
                    <i class="fas fa-star fa-2x "></i>
                    <i class="fas fa-star fa-2x "></i>
                    <i class="fas fa-star fa-2x "></i>
                    <span class="fa fa-2x"><h5>{this.hotel.votes} Votes</h5></span>
                    <span>Average rating : {this.hotel.averageRating}</span>
                    </a>
                </h2>
                
                <hr />
                
                <hr />
                <div class="description description-tabs" >
                    <ul id="myTab" class="nav nav-pills">
                        <li class="active"><a href="#more-information" data-toggle="tab" class="no-margin"> Description </a></li>
                        <li class=""><a href="#reviews" data-toggle="tab">Reviews</a></li>
                        <li class=""><a href="#weather" data-toggle="tab">Weather Statistics</a></li>
                        <li class=""><a href="#pollution" data-toggle="tab">Pollution</a></li>
                        <li class=""><a href="#covid" data-toggle="tab">Covid-19 Statistics</a></li>
                        <li class=""><a href="#covid-news" data-toggle="tab">Covid News</a></li>
                        <li class=""><a href="#restaurant" data-toggle="tab">Restaurant Statistics</a></li>
                        <li class=""><a href="#map" data-toggle="tab">Heat Map</a></li>
                    </ul>
                    <div id="myTabContent" class="tab-content" >
                        <div class="tab-pane fade active in" id="more-information" style={{fontSize:'20px'}}>
                            <br />
                            <strong>Hotel Description</strong>
                            {this.hotelInfo.desc}
                        </div>

                        

                        <div class="tab-pane fade" id="reviews" style={{fontSize:'20px'}}>
                            <br />
                            {ReviewForm}

                            <div class="chat-body no-padding profile-message">
                                <ul>
                                    {this.items}
                                </ul>
                            </div>
                        </div>


                        <div style={{fontSize:'20px'}} class="tab-pane fade" id="weather" style={{position:'relative',left:'20%',fontSize:'20px'}}>

                              <div class="container">
                                <div class="tab-pane active " id="profile">
                                  <div class="weathertitle">
                                    <h2 >Weather <i class="fas fa-cloud-sun"></i></h2>
                                    </div>
                                  
                                  <div class="">
                                      

                                  <div class="weather-data">
                                  <div class="data">
                                        <p>Max wind speed:</p>
                                        <h2 class="confirmed">{weather.windSpeed}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Solar radiation:</p>
                                        <h2 class="death">{weather.solarRad}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Clouds:</p>
                                        <h2 class="recovered">{weather.clouds}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Precipitations:</p>
                                        <h2 class="confirmed">{weather.prec}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Pressure:</p>
                                        <h2 class="death">{weather.pressure}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Snow:</p>
                                        <h2 class="recovered">{weather.snow}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Max temperature:</p>
                                        <h2 class="confirmed">{weather.maxTemp}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Max UV:</p>
                                        <h2 class="death">{weather.maxUV}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Min temperature:</p>
                                        <h2 class="recovered">{weather.minTemp}</h2>
                                    </div>
                                  </div>
                                </div>
                            </div>

                        </div>

                    </div>



                    <div class="tab-pane fade" id="pollution" style={{fontSize:'20px'}}>
                        <div class="container" style={{position:'relative',left:'30%',fontSize:'20px'}}>
                          <div class="pollutiontitle">
                            <h2 >Pollution <i class="fas fa-biohazard"></i></h2>
                            </div>
                            

                          <div class="weather-data" >
                          <div class="data">
                                        <p>Air Quality Index:</p>
                                        <h2 class="recovered">{pollution.airQualityIndex}</h2>
                                    </div>
                                    <div class="data">
                                        <p>PM10 Value:</p>
                                        <h2 class="confirmed">{pollution.pm10Value}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Air Pressure:</p>
                                        <h2 class="death">{pollution.airPressure}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Air Humidity:</p>
                                        <h2 class="recovered">{pollution.airHumidity}</h2>
                                    </div>
                          </div>
                    </div>
                </div>


                <div class="tab-pane fade active in" id="covid" style={{fontSize:'20px'}}>

                            <div class="content" style={{position:'relative',left:'20%',fontSize:'20px'}}>
                                <div class="tab-pane active " id="profile">
                     <div class="col-sm">
                                        <div class="logo">
                            <h2 >C<i class="fas fa-virus "></i>vid-19</h2>
                                        </div>


                                    
                        </div>

                                    <div class="data">
                                        <p>Coronavirus Cases:</p>
                                        <h2 class="confirmed">{covid.covidNewCases}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Deaths:</p>
                                        <h2 class="death">{covid.covidNewDeaths}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Recovered:</p>
                                        <h2 class="recovered">{covid.covidNewCases-covid.covidNewDeaths}</h2>
                                    </div>




                                 </div>
                            </div>
                        </div>

                <div class="tab-pane fade" id="covid-news">
                    <div class="container" style={{position:'relative',fontSize:'20px'}}>
                      <div class="pollutiontitle">
                        <h2 ><i>Covid News</i></h2>
                        </div>
    
                        {covidNewsHtml}

                          </div>
                        </div>


                        <div class="tab-pane fade" id="restaurant">
                    <div class="container" style={{position:'relative',left:'25%',fontSize:'20px'}}>
                      <div class="pollutiontitle">
                        <h2 ><i>Restaurant Statistics</i></h2>
                        </div>
                        <div class="search-br2">

                            
                            <div class="weather-data">
                          <div class="data">
                                    <div class="data">
                                        <p>Simple Meal 1 Person:</p>
                                        <h2 class="recovered">{restaurant.simpleMeal1PersonPrice}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Full Meal 2 Persons:</p>
                                        <h2 class="confirmed">{restaurant.fullMeal2PersonsPrice}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Beer Draught:</p>
                                        <h2 class="death">{restaurant.beerDraughtPrice}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Beer Bottle:</p>
                                        <h2 class="recovered">{restaurant.beerBottlePrice}</h2>
                                    </div>
                                    <p>Cappuccino :</p>
                                        <h2 class="recovered">{restaurant.cappuccinoPrice}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Water :</p>
                                        <h2 class="confirmed">{restaurant.waterPrice}</h2>
                                    </div>
                                    <div class="data">
                                        <p>Coke:</p>
                                        <h2 class="death">{restaurant.cokePrice}</h2>
                                    </div>
                                    <div class="data">
                                        <p>MC Meal:</p>
                                        <h2 class="recovered">{restaurant.mcMealPrice}</h2>
                                    </div>
                          </div>
                        </div>


                          </div>
                          </div>

                          <div class="tab-pane fade" id="map">
                            
                            <Test location={this.mapLoc} country="Romania"/>
                        </div>

                    </div>
                </div>
                
                    
                </div>
            </div>
        </div>
    </div>
</div>
        );
    }
}

export default HotelInfoPage;